'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var IconButton = _interopDefault(require('@material-ui/core/IconButton'));
var CloseIcon = _interopDefault(require('@material-ui/icons/Close'));
var styledComponents = require('../styled-components.js');

var ConversationSnackBar = function (props) {
    var open = props.open, onClose = props.onClose, message = props.message;
    return (React__default.createElement(styledComponents.StyledSnackbar, { anchorOrigin: {
            vertical: 'top',
            horizontal: 'center',
        }, open: open, onClose: onClose, message: message, action: React__default.createElement(React__default.Fragment, null,
            React__default.createElement(IconButton, { size: 'small', "aria-label": 'close', color: 'inherit', onClick: onClose },
                React__default.createElement(CloseIcon, { fontSize: 'small' }))) }));
};

module.exports = ConversationSnackBar;
